module.exports = __webpack_public_path__ + "static/media/lanternfish.f5b6829b.jpg";